module.exports = __webpack_public_path__ + "img/dishes-icon.90a13de8.jpg";